import { createApp } from 'vue'
import App from './App.vue'
import installElementPlus from './plugins/element'
import router from './router'
import '@/assets/reset.css'
import ElementPlus from 'element-plus';
import './assets/iconfont/iconfont.css'


const app = createApp(App).use(router)
installElementPlus(app)
app.use(router).use(ElementPlus)
app.mount('#app');